export const removeStorage = (key: string) => localStorage.removeItem(key);
export const getStorage = <T>(key: string): T | null => JSON.parse(localStorage.getItem(key)?.trim() || "null");
export const setStorage = <T>(key: string, value: T): T => {
  localStorage.setItem(key, JSON.stringify(value));
  return value;
};
